var map = {
	"./account-circle.svg": 189,
	"./account.svg": 2808,
	"./arrow-circle.svg": 5690,
	"./arrow.svg": 4256,
	"./basket.svg": 9918,
	"./burger.svg": 5909,
	"./certificates.svg": 6433,
	"./check.svg": 1856,
	"./checked.svg": 2093,
	"./close.svg": 7461,
	"./configeditor.svg": 5794,
	"./dns.svg": 9540,
	"./download.svg": 3796,
	"./edit.svg": 8978,
	"./editor.svg": 2363,
	"./eye.svg": 2832,
	"./eye_closed.svg": 7658,
	"./info.svg": 1399,
	"./information-outline.svg": 770,
	"./keyboard_arrow_left.svg": 6754,
	"./lang.svg": 8540,
	"./list.svg": 7400,
	"./lock.svg": 1110,
	"./log.svg": 9297,
	"./logging.svg": 5950,
	"./logo.svg": 4386,
	"./luaeditor.svg": 5063,
	"./menu.svg": 3019,
	"./mqtt.svg": 8108,
	"./network.svg": 5733,
	"./ntp.svg": 979,
	"./partitions.svg": 7169,
	"./plus.svg": 324,
	"./reboot.svg": 48,
	"./save.svg": 6720,
	"./script-text.svg": 4787,
	"./smtp.svg": 2392,
	"./snmp.svg": 4775,
	"./success.svg": 5780,
	"./syslog.svg": 7453,
	"./system.svg": 8286,
	"./systeminfo.svg": 3935,
	"./translate.svg": 9847,
	"./update.svg": 2342,
	"./upload.svg": 4022,
	"./users.svg": 863,
	"./webserver.svg": 6410,
	"./wifi.svg": 2471
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7254;